export const SET_CURRENT_INDEX = 'SET_CURRENT_INDEX';
export const SET_FLATTEN_STEPS = 'SET_FLATTEN_STEPS';
export const SET_TYPE = 'SET_TYPE';
export const RESET_TUNNEL = 'RESET_TUNNEL';
